import { render, staticRenderFns } from "./HistorialTiposProducto.vue?vue&type=template&id=4649c5e4&scoped=true&"
import script from "./HistorialTiposProducto.vue?vue&type=script&lang=ts&"
export * from "./HistorialTiposProducto.vue?vue&type=script&lang=ts&"
import style0 from "./HistorialTiposProducto.vue?vue&type=style&index=0&id=4649c5e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4649c5e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4649c5e4', component.options)
    } else {
      api.reload('4649c5e4', component.options)
    }
    module.hot.accept("./HistorialTiposProducto.vue?vue&type=template&id=4649c5e4&scoped=true&", function () {
      api.rerender('4649c5e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/TiposProducto/HistorialTiposProducto.vue"
export default component.exports